import { toast } from 'react-toastify';
import CustomToast from '../components/common/customToast/CustomToast';

export const displayNotifications = (notifications) => {
    // create styles and add them to the head
    createToastNotificationsStyles(notifications);

    for (const notification of notifications) {
        toast(
            <CustomToast
                text={notification.text}
                textColor={notification.textColor}
                url={notification.url}
            />,
            {
                position: notification.position || 'top-left',
                icon: ({ theme, type }) => <img src={notification.icon} />,
                autoClose: notification.autoClose,
                delay: notification.delay,
                closeOnClick: notification.closeOnClick,
                className: `ab-notification-toast-${notification.id}`,
                progressClassName: `ab-notification-toast-${notification.id}-progress-bar`,
                style: notification.style,
            }
        );
    }
};

export const createToastNotificationsStyles = (notifications) => {
    const styles = document.createElement('style');

    for (const notification of notifications) {
        if (notification.backgroundColor) {
            styles.innerHTML += `.ab-notification-toast-${notification.id} { background-color: ${notification.backgroundColor} !important; }`;
            styles.innerHTML += '\n';
        }

        if (notification.progressBarBackgroundColor) {
            styles.innerHTML += `.ab-notification-toast-${notification.id}-progress-bar { background-color: ${notification.progressBarBackgroundColor} !important; }`;
            styles.innerHTML += '\n';

            styles.innerHTML += `.ab-notification-toast-${notification.id}-progress-bar.Toastify__progress-bar-theme--light { background: transparent; }`;
        }

        if (notification.textColor) {
            styles.innerHTML += '\n';
            styles.innerHTML += `.ab-notification-toast-${notification.id} .Toastify__close-button--light { color: ${notification.textColor} !important; }`;
        }
    }

    document.getElementsByTagName('head')[0].appendChild(styles);
};
